import { render } from "./Message.vue?vue&type=template&id=26a16fd8&ts=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26a16fd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26a16fd8', __exports__)) {
    api.reload('26a16fd8', __exports__)
  }
  
  module.hot.accept("./Message.vue?vue&type=template&id=26a16fd8&ts=true", () => {
    api.rerender('26a16fd8', render)
  })

}


export default __exports__